import "animate.css";
import 'bulma-checkradio/dist/css/bulma-checkradio.min.css';
import 'bulma-switch/dist/css/bulma-switch.min.css';
import "bulma/css/bulma.min.css"; // Import Bulma CSS
import 'react-tooltip/dist/react-tooltip.css';
import "./assets/scss/App.scss";
// main.tsx or main.js

import { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import 'react-tooltip/dist/react-tooltip.css';

import { SiteProvider } from "./contexts/SiteProvider";
import SiteRoute from "./routing/SiteRoute";

function App() {
  useEffect(() => {
    window.loaderType = 'STAR';
  }, []);

  return (

    <SiteProvider>
      <div className="App">
        <SiteRoute />
      </div>
    </SiteProvider>
  );
}

export default App;
